export type EmbedHeaderCloseAction = 'close' | 'complete-and-close';

export interface EmbedHeaderConfig {
  showBackButton?: boolean;
  backUrl?: string;
  backReplaceUrl?: boolean;
  hideBackWhenQueryParam?: string;
  showReportIssueButton?: boolean;
  reportIssueQueryParamMap?: Readonly<Record<string, string>>;
  showProfileButton?: boolean;
  showCloseButton?: boolean;
  closeAction?: EmbedHeaderCloseAction;
}

export const DEFAULT_EMBED_HEADER_CONFIG: Required<
  Pick<
    EmbedHeaderConfig,
    | 'showBackButton'
    | 'showReportIssueButton'
    | 'showProfileButton'
    | 'showCloseButton'
    | 'closeAction'
  >
> = {
  showBackButton: false,
  showReportIssueButton: false,
  showProfileButton: false,
  showCloseButton: true,
  closeAction: 'close',
};
